import { useEffect, useState, useRef } from "react";
import "./Campaings.scss";
import { ContentCopy, FilterList, Close } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import useAdminUser from "../../../data/useAdminUser";
import { format as dateFormat } from "date-fns";
import { INIT_FILTER_VALUE, cloneCampaignFilters } from "./filters";
import DataTable from "../Table/Datatable";
import DateFromTo from "../../../widgets/DateFromTo/DateFromTo";
import {
  FormControl,
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Chip,
} from "@mui/material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { DOMAIN_API_HOST, getDomainConfig } from "../../../configs/main";
import SortPopup from "../SortPopUp/SortPopup";
import EditModal from "./EditModal";
import EditStatusModal from "./EditStatusModal";
import DeleteModal from "./DeleteModal";
import { CtrViewModal } from "./CtrModal";

const STATUS_TYPE = {
  INACTIVE: "Неактивна",
  WORK: "Работает",
  MODERATION: "На модерации",
  ERROR: "Ошибка",
};

const TARGET_TYPE = {
  TRAFFIC: "Трафик",
  REACH: "Охват",
};

const ITEMS_PER_PAGE = 15;

const formatApiDate = (value) => {
  if (!value) return "";
  try {
    return dateFormat(value instanceof Date ? value : new Date(value), "yyyy-MM-dd");
  } catch (_) {
    return "";
  }
};

const formatDisplayDate = (value) => {
  if (!value) return "";
  try {
    return dateFormat(value instanceof Date ? value : new Date(value), "dd.MM.yyyy");
  } catch (_) {
    return String(value);
  }
};

const formatViews = (value) =>
  Number(value || 0).toLocaleString("ru-RU");

const INIT_IMPRESSIONS_FORM = {
  mode: "add",
  dateMode: "period",
  amountMode: "daily_average",
  amount: "",
  advertisementIds: [],
  allAdvertisements: false,
  period: { date_start: "", date_end: "" },
  selectedDays: [],
  dayToAdd: null,
};

const formatRangeChip = (range, label) => {
  if (!range?.start && !range?.end) return null;
  if (range.start && range.end) return `${label}: ${range.start}–${range.end}`;
  if (range.start) return `${label}: от ${range.start}`;
  return `${label}: до ${range.end}`;
};

const formatDateChip = (date) => {
  if (!date) return "";
  try {
    return dateFormat(date instanceof Date ? date : new Date(date), "dd.MM.yyyy");
  } catch (_) {
    return "";
  }
};

function Campaigns() {
  const { enqueueSnackbar } = useSnackbar();
  const { role } = useAdminUser();
  const isManagerRetargeo = role === "MANAGER_RETARGEO";
  const isSuperuser = role === "SUPERUSER";
  const [filterArr, setFilter] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [ctrViewModal, setCtrViewModal] = useState(false);
  const [impressionsModal, setImpressionsModal] = useState(false);
  const [impressionsForm, setImpressionsForm] = useState(INIT_IMPRESSIONS_FORM);
  const [impressionsResult, setImpressionsResult] = useState(null);
  const [impressionsSubmitting, setImpressionsSubmitting] = useState(false);
  const [impressionsAds, setImpressionsAds] = useState([]);
  const [impressionsAdsLoading, setImpressionsAdsLoading] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [current, setCurrent] = useState();
  const [upd, setUpd] = useState(false);
  const [filtersValue, setValue] = useState(INIT_FILTER_VALUE);
  const [draftFilters, setDraftFilters] = useState(INIT_FILTER_VALUE);
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);
  const [brand, setBrand] = useState(getDomainConfig().brand);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingDots, setLoadingDots] = useState("");
  const [showLongLoadingMessage, setShowLongLoadingMessage] = useState(false);
  const abortControllerRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [shouldResetPage, setShouldResetPage] = useState(false);

  const buildApiFilters = (source = filtersValue) => {
    const filters = {};

    if (brand) filters.brand = brand;
    if (source.id) filters.id = source.id;
    if (source.name) filters.name = source.name;
    if (source.site) filters.site = source.site;
    if (source.campaign_creator_email) {
      filters.campaign_creator_email = source.campaign_creator_email;
    }
    if (source.type) filters.target_type = source.type;
    if (source.status) filters.status = source.status;

    if (source.created_at?.date_start || source.created_at?.date_end) {
      filters.created_at = {};
      if (source.created_at.date_start) filters.created_at.from = source.created_at.date_start;
      if (source.created_at.date_end) filters.created_at.to = source.created_at.date_end;
    }

    if (source.range?.date_start || source.range?.date_end) {
      filters.validity_period = {};
      if (source.range.date_start) filters.validity_period.from = source.range.date_start;
      if (source.range.date_end) filters.validity_period.to = source.range.date_end;
    }

    if (source.daily_budget?.start || source.daily_budget?.end) {
      filters.daily_budget = {};
      if (source.daily_budget.start) filters.daily_budget.from = +source.daily_budget.start;
      if (source.daily_budget.end) filters.daily_budget.to = +source.daily_budget.end;
    }

    if (source.full_budget?.start || source.full_budget?.end) {
      filters.full_budget = {};
      if (source.full_budget.start) filters.full_budget.from = +source.full_budget.start;
      if (source.full_budget.end) filters.full_budget.to = +source.full_budget.end;
    }

    if (source.bet?.start || source.bet?.end) {
      filters.price_per_action = {};
      if (source.bet.start) filters.price_per_action.from = +source.bet.start;
      if (source.bet.end) filters.price_per_action.to = +source.bet.end;
    }

    if (source.decrease?.start || source.decrease?.end) {
      filters.charges_sum = {};
      if (source.decrease.start) filters.charges_sum.from = +source.decrease.start;
      if (source.decrease.end) filters.charges_sum.to = +source.decrease.end;
    }

    if (source.sort) {
      const sortValue = String(source.sort);
      if (sortValue.startsWith("created_at")) {
        filters.sort_by_created_at = sortValue.includes("asc") ? 1 : -1;
      }
      if (sortValue.startsWith("daily_budget")) {
        filters.sort_by_daily_budget = sortValue.includes("asc") ? 1 : -1;
      }
      if (sortValue.startsWith("full_budget")) {
        filters.sort_by_full_budget = sortValue.includes("asc") ? 1 : -1;
      }
    }

    return filters;
  };

  useEffect(() => {
    async function fetchData() {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      const currentController = abortControllerRef.current;

      setIsLoading(true);
      setFilter([]);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(
          "Authorization",
          "Bearer " + localStorage.getItem("admin_token")
        );

        const apiFilters = buildApiFilters();
        const res = await fetch(
          `${DOMAIN_API_HOST}/api/v1/admin/campaigns?brand=${brand}&page=${currentPage}&limit=${ITEMS_PER_PAGE}`,
          {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(apiFilters),
            signal: currentController.signal,
          }
        );

        if (currentController.signal.aborted) return;

        if (res.ok) {
          const data = await res.json();
          if (!currentController.signal.aborted) {
            if (data.data && Array.isArray(data.data)) {
              setFilter(data.data);
              setTotalPages(data.total_pages || 1);
            } else if (Array.isArray(data)) {
              setFilter(data);
              setTotalPages(Math.ceil(data.length / ITEMS_PER_PAGE) || 1);
            } else {
              setFilter([]);
              setTotalPages(1);
            }
          }
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Ошибка при загрузке кампаний:", error);
        }
      } finally {
        if (!currentController.signal.aborted) {
          setIsLoading(false);
        }
      }
    }

    fetchData();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [currentPage, filtersValue, upd, isDeleteModal, brand]);

  useEffect(() => {
    if (!isLoading) {
      setLoadingDots("");
      setShowLongLoadingMessage(false);
      return;
    }
    const dotsInterval = setInterval(() => {
      setLoadingDots((prev) => (prev === "..." ? "" : prev + "."));
    }, 200);
    const messageTimeout = setTimeout(() => setShowLongLoadingMessage(true), 3000);
    return () => {
      clearInterval(dotsInterval);
      clearTimeout(messageTimeout);
    };
  }, [isLoading]);

  useEffect(() => {
    setCurrentPage(1);
  }, [brand]);

  useEffect(() => {
    if (isManagerRetargeo && brand !== "retargeo") {
      setBrand("retargeo");
    }
  }, [isManagerRetargeo, brand]);

  useEffect(() => {
    if (shouldResetPage && currentPage !== 1) {
      setCurrentPage(1);
      setShouldResetPage(false);
    } else if (shouldResetPage) {
      setShouldResetPage(false);
    }
  }, [shouldResetPage, currentPage]);

  const openFiltersModal = () => {
    setDraftFilters(cloneCampaignFilters(filtersValue));
    setFiltersModalOpen(true);
  };

  const applyDraftFilters = () => {
    setValue(
      cloneCampaignFilters({
        ...draftFilters,
        id: filtersValue.id,
        site: filtersValue.site,
        campaign_creator_email: filtersValue.campaign_creator_email,
      })
    );
    setShouldResetPage(true);
    setFiltersModalOpen(false);
  };

  const resetDraftFilters = () => {
    setDraftFilters(
      cloneCampaignFilters({
        ...INIT_FILTER_VALUE,
        sort: filtersValue.sort,
        id: filtersValue.id,
        site: filtersValue.site,
        campaign_creator_email: filtersValue.campaign_creator_email,
      })
    );
  };

  const clearAllFilters = () => {
    setValue(
      cloneCampaignFilters({
        ...INIT_FILTER_VALUE,
        sort: filtersValue.sort,
        id: filtersValue.id,
        site: filtersValue.site,
        campaign_creator_email: filtersValue.campaign_creator_email,
      })
    );
    setShouldResetPage(true);
  };

  const handleDraftChange = (key, value) => {
    setDraftFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSortChange = (item) => {
    setValue((prev) => ({ ...prev, sort: item.type }));
    setShouldResetPage(true);
  };

  const getActiveFilterChips = () => {
    const chips = [];
    const f = filtersValue;

    if (f.name) chips.push({ key: "name", label: `Название: ${f.name}` });
    if (f.type) chips.push({ key: "type", label: `Тип: ${TARGET_TYPE[f.type] || f.type}` });
    if (f.status) chips.push({ key: "status", label: `Статус: ${STATUS_TYPE[f.status] || f.status}` });

    if (f.created_at?.date_start || f.created_at?.date_end) {
      const from = formatDateChip(f.created_at.date_start);
      const to = formatDateChip(f.created_at.date_end);
      let dateLabel = "Дата создания";
      if (from && to) dateLabel = `Создана: ${from}–${to}`;
      else if (from) dateLabel = `Создана: от ${from}`;
      else if (to) dateLabel = `Создана: до ${to}`;
      chips.push({ key: "created_at", label: dateLabel });
    }

    if (f.range?.date_start || f.range?.date_end) {
      const from = formatDateChip(f.range.date_start);
      const to = formatDateChip(f.range.date_end);
      let dateLabel = "Период";
      if (from && to) dateLabel = `Период: ${from}–${to}`;
      else if (from) dateLabel = `Период: от ${from}`;
      else if (to) dateLabel = `Период: до ${to}`;
      chips.push({ key: "range", label: dateLabel });
    }

    const dailyLabel = formatRangeChip(f.daily_budget, "Дн. бюджет");
    if (dailyLabel) chips.push({ key: "daily_budget", label: dailyLabel });
    const fullLabel = formatRangeChip(f.full_budget, "Общ. бюджет");
    if (fullLabel) chips.push({ key: "full_budget", label: fullLabel });
    const betLabel = formatRangeChip(f.bet, "Ставка");
    if (betLabel) chips.push({ key: "bet", label: betLabel });
    const decreaseLabel = formatRangeChip(f.decrease, "Списания");
    if (decreaseLabel) chips.push({ key: "decrease", label: decreaseLabel });

    return chips;
  };

  const removeActiveFilter = (key) => {
    const defaults = {
      id: "",
      name: "",
      site: "",
      campaign_creator_email: "",
      type: "",
      status: "",
      created_at: { date_start: "", date_end: "" },
      range: { date_start: "", date_end: "" },
      daily_budget: { start: "", end: "" },
      full_budget: { start: "", end: "" },
      bet: { start: "", end: "" },
      decrease: { start: "", end: "" },
    };
    if (key in defaults) {
      setValue((prev) => ({ ...prev, [key]: defaults[key] }));
      setShouldResetPage(true);
    }
  };

  const activeFilterChips = getActiveFilterChips();
  const activeFiltersCount = activeFilterChips.length;

  const columns = [
    {
      Header: "ID РК",
      accessor: "id",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Название",
      accessor: "name",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Сайт",
      accessor: "site",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Почта клиента",
      accessor: "campaign_creator_email",
      maxWidth: 400,
      minWidth: 80,
      width: 250,
    },
    {
      Header: "Дата создания",
      accessor: "created_at",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Тип РК",
      accessor: "type",
      maxWidth: 400,
      minWidth: 60,
      width: 117,
    },
    {
      Header: "Дневной бюджет",
      accessor: "daily_budget",
      maxWidth: 400,
      minWidth: 80,
      width: 145,
    },
    {
      Header: "Общий бюджет",
      accessor: "full_budget",
      maxWidth: 400,
      minWidth: 80,
      width: 145,
    },
    {
      Header: "Ставка",
      accessor: "bet",
      maxWidth: 400,
      minWidth: 80,
      width: 130,
    },
    {
      Header: "Период с-по",
      accessor: "range",
      maxWidth: 400,
      minWidth: 80,
      width: 200,
    },
    {
      Header: "Сумма спис",
      accessor: "charge",
      maxWidth: 400,
      minWidth: 50,
      width: 150,
    },
    {
      Header: "Статус",
      accessor: "status",
      maxWidth: 400,
      minWidth: 50,
      width: 200,
    },
    {
      Header: "CTR",
      accessor: "ctr",
      maxWidth: 360,
      minWidth: 50,
      width: 100,
    },
    ...(isSuperuser
      ? [
        {
          Header: "Управление показами",
          accessor: "impressions",
          maxWidth: 360,
          minWidth: 50,
          width: 120,
        },
      ]
      : []),
    {
      Header: "Удаление РК",
      accessor: "delete",
      maxWidth: 360,
      minWidth: 50,
      width: 100,
    },
  ];

  function getTableData() {
    return filterArr?.map((el) => {
      return {
        id: (
          <div
            className="td"
            style={{ display: "flex", flexDirection: "row", borderRadius: 5 }}
          >
            {el.id.slice(0, 8)}
            <ContentCopy
              style={{ marginLeft: 5, cursor: "pointer" }}
              onClick={() => {
                navigator.clipboard.writeText(el.id);
                enqueueSnackbar("ID кампании скопирован", {
                  variant: "success",
                  autoHideDuration: 1000,
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                });
              }}
              className="copyIcon"
              fontSize="small"
            />
          </div>
        ),
        name: <div className="td">{el.name ? el.name : "-"}</div>,
        site: (
          <div className="td" style={{ display: "flex", flexDirection: "row" }}>
            <span>{el.site ? el.site : "-"}</span>
            {el.site && (
              <ContentCopy
                style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => {
                  navigator.clipboard.writeText(el.site);
                  enqueueSnackbar("Сайт кампании скопирован", {
                    variant: "success",
                    autoHideDuration: 1000,
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                  });
                }}
                className="copyIcon"
                fontSize="small"
              />
            )}
          </div>
        ),
        campaign_creator_email: (
          <div className="td" style={{ display: "flex", flexDirection: "row" }}>
            <span>{el.campaign_creator_email ? el.campaign_creator_email : "-"}</span>
            {el.campaign_creator_email && (
              <ContentCopy
                style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => {
                  navigator.clipboard.writeText(el.campaign_creator_email);
                  enqueueSnackbar("Почта клиента скопирована", {
                    variant: "success",
                    autoHideDuration: 1000,
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                  });
                }}
                className="copyIcon"
                fontSize="small"
              />
            )}
          </div>
        ),
        created_at: (
          <div className="td">
            {dateFormat(Date.parse(el.created_at), "dd/MM/yyyy")}
          </div>
        ),
        type: (
          <div className="td">
            {TARGET_TYPE[el.target_type] || el.target_type || "-"}
          </div>
        ),
        daily_budget: <div className="td">{el.daily_budget}</div>,
        full_budget: <div className="td">{el.full_budget}</div>,
        bet: <div className="td">{el.price_per_action}</div>,
        range: (
          <div className="td">
            {el.validity_period?.date_start
              ? dateFormat(Date.parse(new Date(el.validity_period.date_start)), "dd/MM/yyyy")
              : "-"}
            -
            {el.validity_period?.date_end
              ? dateFormat(Date.parse(new Date(el.validity_period.date_end)), "dd/MM/yyyy")
              : "-"}
          </div>
        ),
        charge: <div className="td">{el.charges_sum}</div>,
        status: (
          <div className="td">
            {STATUS_TYPE[el.status] || el.status}{" "}
            {["ADMIN", "SUPERUSER"].some((r) => r === role) &&
              !["ERROR", "INACTIVE"].includes(el.status) && (
                <svg
                  onClick={() => {
                    setCurrent(el);
                    setStatusModal(true);
                  }}
                  style={{ marginLeft: 10, cursor: "pointer" }}
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.49968 1.25391C9.051 1.25391 8.60238 1.424 8.26237 1.76416L2.72868 7.29736C2.62369 7.40236 2.54679 7.53293 2.50603 7.67627L1.76433 10.2734C1.74603 10.3377 1.74524 10.4057 1.76204 10.4704C1.77883 10.535 1.8126 10.594 1.85985 10.6413C1.90709 10.6885 1.96611 10.7223 2.03078 10.7391C2.09545 10.7559 2.16344 10.7551 2.22771 10.7368L4.82536 9.99512L4.82585 9.99463C4.96823 9.9537 5.09848 9.87776 5.20378 9.77246L10.737 4.23877C11.4173 3.55849 11.4173 2.44444 10.737 1.76416C10.397 1.424 9.94835 1.25391 9.49968 1.25391ZM9.49968 1.99951C9.75488 1.99951 10.0097 2.09784 10.2062 2.29443H10.2067C10.6004 2.68815 10.6004 3.31478 10.2067 3.7085L9.72185 4.19336L8.30778 2.7793L8.79265 2.29443C8.98914 2.09784 9.24448 1.99951 9.49968 1.99951ZM7.77751 3.30957L9.19157 4.72363L4.67302 9.24219C4.65836 9.25675 4.6398 9.2679 4.61882 9.27393L2.67058 9.83057L3.22722 7.88184V7.88135C3.23295 7.86119 3.24345 7.84314 3.25896 7.82764L7.77751 3.30957Z"
                    fill="black"
                  />
                </svg>
              )}
          </div>
        ),
        ctr: (
          <button
            onClick={() => {
              setCurrent(el);
              setCtrViewModal(true);
            }}
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "500",
              borderRadius: 5,
              background: "#DFE8FF",
              color: "#3F73F9",
            }}
          >
            Изменить
          </button>
        ),
        ...(isSuperuser
          ? {
            impressions: (
                <button
                  onClick={() => openImpressionsModal(el)}
                  style={{
                    padding: "5px 10px",
                    fontSize: "12px",
                    fontWeight: "500",
                    borderRadius: 5,
                    background: "#DFE8FF",
                    color: "#3F73F9",
                  }}
                >
                  Добавить
                </button>
            ),
          }
          : {}),
        delete: (
          <div
            onClick={() => {
              setCurrent(el);
              setDeleteModal(true);
            }}
            style={{ padding: "5px", cursor: "pointer", opacity: ".8" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="#0d0d0d"
              viewBox="0 0 256 256"
            >
              <path d="M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z"></path>
            </svg>
          </div>
        ),
      };
    });
  }

  const downloadFile = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("admin_token")
    );
    const response = await fetch(`${DOMAIN_API_HOST}/api/v1/admin/campaigns/download?brand=${brand}`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(buildApiFilters()),
    });
    if (response.ok) {
      const link = document.createElement("a");
      let filename = response.headers
        ?.get("content-disposition")
        ?.split("filename=")[1];
      const blob = await response.blob();
      if (!filename) filename = "Campaigns.csv";
      link.download = filename;
      link.href = window.URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const closeImpressionsModal = () => {
    setImpressionsModal(false);
    setImpressionsForm(INIT_IMPRESSIONS_FORM);
    setImpressionsResult(null);
    setImpressionsSubmitting(false);
    setImpressionsAds([]);
    setImpressionsAdsLoading(false);
  };

  const loadCampaignAdvertisements = async (campaignId) => {
    if (!campaignId) return;
    setImpressionsAdsLoading(true);
    setImpressionsAds([]);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const response = await fetch(
        `${DOMAIN_API_HOST}/api/v1/admin/campaigns/${campaignId}/advertisements`,
        {
          method: "GET",
          headers: myHeaders,
        }
      );
      if (!response.ok) {
        throw new Error("Не удалось загрузить объявления кампании");
      }
      const data = await response.json();
      const list = Array.isArray(data) ? data : [];
      setImpressionsAds(list);
      if (list.length === 1) {
        setImpressionsForm((prev) => ({
          ...prev,
          advertisementIds: [String(list[0].id)],
        }));
      }
    } catch (error) {
      enqueueSnackbar(error.message || "Ошибка загрузки объявлений", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setImpressionsAdsLoading(false);
    }
  };

  const openImpressionsModal = (campaign) => {
    setCurrent(campaign);
    setImpressionsForm(INIT_IMPRESSIONS_FORM);
    setImpressionsResult(null);
    setImpressionsModal(true);
    loadCampaignAdvertisements(campaign.id);
  };

  const updateImpressionsForm = (patch) => {
    setImpressionsForm((prev) => ({ ...prev, ...patch }));
  };

  const addSelectedDay = () => {
    const day = formatApiDate(impressionsForm.dayToAdd);
    if (!day) {
      enqueueSnackbar("Выберите дату", {
        variant: "warning",
        autoHideDuration: 2000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }
    if (impressionsForm.selectedDays.includes(day)) {
      enqueueSnackbar("Эта дата уже добавлена", {
        variant: "info",
        autoHideDuration: 2000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }
    updateImpressionsForm({
      selectedDays: [...impressionsForm.selectedDays, day].sort(),
      dayToAdd: null,
    });
  };

  const removeSelectedDay = (day) => {
    updateImpressionsForm({
      selectedDays: impressionsForm.selectedDays.filter((item) => item !== day),
    });
  };

  const submitImpressions = async () => {
    const isDelete = impressionsForm.mode === "delete";
    let amount = 0;

    if (!isDelete) {
      amount = Number(impressionsForm.amount);
      if (!Number.isInteger(amount) || amount <= 0) {
        enqueueSnackbar("Укажите целое положительное количество показов", {
          variant: "error",
          autoHideDuration: 2500,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        return;
      }
    }

    const allAdvertisements = !!impressionsForm.allAdvertisements;

    if (!isDelete && !allAdvertisements && !impressionsForm.advertisementIds?.length) {
      enqueueSnackbar("Выберите хотя бы одно объявление", {
        variant: "error",
        autoHideDuration: 2500,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
      return;
    }

    if (!allAdvertisements && impressionsForm.advertisementIds?.length) {
      const selectedAds = impressionsAds.filter((ad) =>
        impressionsForm.advertisementIds.includes(String(ad.id))
      );
      const adWithoutBanners = selectedAds.find(
        (ad) => Number(ad.banners_count || 0) === 0
      );
      if (adWithoutBanners) {
        enqueueSnackbar(
          `У объявления «${adWithoutBanners.head || adWithoutBanners.id}» нет баннеров`,
          {
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }
        );
        return;
      }
    }

    const body = {
      mode: impressionsForm.mode,
    };
    if (allAdvertisements) {
      body.all_advertisements = true;
    } else {
      body.advertisement_ids = impressionsForm.advertisementIds || [];
    }

    if (!isDelete) {
      body.amount_mode = impressionsForm.amountMode;
      body.amount = amount;
    }

    if (impressionsForm.dateMode === "period") {
      const dateFrom = formatApiDate(impressionsForm.period.date_start);
      const dateTo = formatApiDate(impressionsForm.period.date_end);
      if (!dateFrom || !dateTo) {
        enqueueSnackbar("Укажите период с датой начала и окончания", {
          variant: "error",
          autoHideDuration: 2500,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        return;
      }
      body.date_from = dateFrom;
      body.date_to = dateTo;
    } else {
      if (!impressionsForm.selectedDays.length) {
        enqueueSnackbar("Добавьте хотя бы один день", {
          variant: "error",
          autoHideDuration: 2500,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        return;
      }
      body.dates = impressionsForm.selectedDays;
    }

    setImpressionsSubmitting(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + localStorage.getItem("admin_token")
      );
      const response = await fetch(
        `${DOMAIN_API_HOST}/api/v1/admin/campaigns/${current.id}/impressions`,
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(body),
        }
      );
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const detail =
          typeof data?.detail === "string"
            ? data.detail
            : Array.isArray(data?.detail)
              ? data.detail.map((item) => item.msg || JSON.stringify(item)).join("; ")
              : isDelete
                ? "Не удалось удалить показы"
                : "Не удалось добавить показы";
        throw new Error(detail);
      }
      setImpressionsResult(data);
      enqueueSnackbar(
        isDelete ? "Показы успешно удалены" : "Показы успешно обработаны",
        {
          variant: "success",
          autoHideDuration: 2500,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        }
      );
    } catch (error) {
      enqueueSnackbar(
        error.message ||
          (isDelete
            ? "Ошибка при удалении показов"
            : "Ошибка при добавлении показов"),
        {
          variant: "error",
          autoHideDuration: 3500,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        }
      );
    } finally {
      setImpressionsSubmitting(false);
    }
  };

  const selectSx = {
    height: 36,
    background: "#f3f4f7",
    borderRadius: "8px",
    fontSize: 14,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "&:hover": {
      background: "#eef0f4",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(63, 115, 249, 0.35)",
    },
    "&.Mui-focused": {
      background: "#fff",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3F73F9",
      borderWidth: "1px",
    },
  };

  const filterSelectMenuProps = {
    disableScrollLock: true,
    disablePortal: true,
    anchorOrigin: { vertical: "bottom", horizontal: "left" },
    transformOrigin: { vertical: "top", horizontal: "left" },
    PaperProps: {
      className: "CampaignsFiltersSelectMenu",
    },
    MenuListProps: {
      className: "CampaignsFiltersSelectMenu-list",
    },
  };

  const impressionsAdsMenuProps = {
    ...filterSelectMenuProps,
    PaperProps: {
      className: "CampaignsImpressionsAdsMenu",
      style: { maxWidth: 420, maxHeight: 320 },
    },
    MenuListProps: {
      className: "CampaignsImpressionsAdsMenu-list",
    },
  };

  const hasDraftCreatedAt =
    !!draftFilters.created_at?.date_start || !!draftFilters.created_at?.date_end;
  const hasDraftRange =
    !!draftFilters.range?.date_start || !!draftFilters.range?.date_end;
  const hasImpressionsPeriod =
    !!impressionsForm.period?.date_start || !!impressionsForm.period?.date_end;

  return (
    <div className="Campaigns">
      <div className="Campaigns-header">
        <div className="Campaigns-headerText">
          <h1>Кампании</h1>
          <p>
            Список и управление рекламными кампаниями
            {brand === "retargeo" ? " Retargeo" : " Programmatic"}
          </p>
        </div>
      </div>

      <div className="Campaigns-toolbar">
        <div className="Campaigns-toolbarLeft">
          <button
            type="button"
            className={
              activeFiltersCount
                ? "Campaigns-filterBtn is-active"
                : "Campaigns-filterBtn"
            }
            onClick={openFiltersModal}
          >
            <FilterList fontSize="small" />
            Фильтры
            {activeFiltersCount > 0 && (
              <span className="Campaigns-filterBadge">{activeFiltersCount}</span>
            )}
          </button>
          {/* <button
            className="Campaigns-csvBtn"
            onClick={() => downloadFile()}
            type="button"
          >
            Скачать CSV
          </button> */}
          <SortPopup
            sortedBy={true}
            title="Сортировать по"
            items={[
              { name: "дате создания", type: "created_at" },
              { name: "общему бюджету", type: "full_budget" },
              { name: "дневному бюджету", type: "daily_budget" },
            ]}
            onChange={handleSortChange}
          />
        </div>
      </div>

      <div className="Campaigns-subbar">
        <div className="Campaigns-brands">
          {!isManagerRetargeo && (
            <button
              type="button"
              className={
                brand === "programmatic"
                  ? "Campaigns-brandBtn is-active"
                  : "Campaigns-brandBtn"
              }
              onClick={() => setBrand("programmatic")}
            >
              Programmatic
            </button>
          )}
          <button
            type="button"
            className={
              brand === "retargeo"
                ? "Campaigns-brandBtn is-active"
                : "Campaigns-brandBtn"
            }
            onClick={() => setBrand("retargeo")}
          >
            Retargeo
          </button>
        </div>
        <div className="Campaigns-quickFilters">
          <input
            className="Campaigns-quickInput"
            value={filtersValue.id}
            onChange={(e) => {
              setValue((prev) => ({ ...prev, id: e.target.value }));
              setShouldResetPage(true);
            }}
            placeholder="ID РК"
          />
          <input
            className="Campaigns-quickInput"
            value={filtersValue.campaign_creator_email}
            onChange={(e) => {
              setValue((prev) => ({
                ...prev,
                campaign_creator_email: e.target.value,
              }));
              setShouldResetPage(true);
            }}
            placeholder="Email"
          />
          <input
            className="Campaigns-quickInput"
            value={filtersValue.site}
            onChange={(e) => {
              setValue((prev) => ({ ...prev, site: e.target.value }));
              setShouldResetPage(true);
            }}
            placeholder="Сайт"
          />
        </div>
      </div>

      {activeFiltersCount > 0 && (
        <div className="Campaigns-chips">
          {activeFilterChips.map((chip) => (
            <button
              key={chip.key}
              type="button"
              className="Campaigns-chip"
              onClick={() => removeActiveFilter(chip.key)}
              title="Сбросить фильтр"
            >
              <span>{chip.label}</span>
              <Close sx={{ fontSize: 14 }} />
            </button>
          ))}
          <button
            type="button"
            className="Campaigns-chipsClear"
            onClick={clearAllFilters}
          >
            Сбросить все
          </button>
        </div>
      )}

      <div className="Campaigns-content">
        {isLoading ? (
          <div className="Campaigns-loading">
            <div>Загружаем таблицу{loadingDots}</div>
            {showLongLoadingMessage && (
              <div className="Campaigns-loadingHint">Собираем данные...</div>
            )}
          </div>
        ) : (
          <>
            <div className="Campaigns-tablePanel">
              <div className="Campaigns-tableScroll">
                <DataTable data={getTableData()} columns={columns} />
              </div>
            </div>
            <div className="Campaigns-pagination">
              <button
                type="button"
                className="Campaigns-pageBtn"
                onClick={() => handlePageChange("prev")}
                disabled={currentPage === 1}
              >
                Назад
              </button>
              <span className="Campaigns-pageInfo">
                {currentPage} / {totalPages}
              </span>
              <button
                type="button"
                className="Campaigns-pageBtn"
                onClick={() => handlePageChange("next")}
                disabled={currentPage === totalPages}
              >
                Дальше
              </button>
            </div>
          </>
        )}
      </div>

      <Dialog
        open={filtersModalOpen}
        onClose={() => setFiltersModalOpen(false)}
        maxWidth="md"
        fullWidth
        className="CampaignsFiltersDialog"
        PaperProps={{ className: "CampaignsFiltersDialog-paper" }}
      >
        <DialogTitle className="CampaignsFiltersDialog-title">
          Фильтры кампаний
        </DialogTitle>
        <DialogContent className="CampaignsFiltersDialog-content" dividers>
          <div className="Campaigns-filtersGrid">
            <label className="Campaigns-field">
              <span>Название</span>
              <input
                value={draftFilters.name}
                onChange={(e) => handleDraftChange("name", e.target.value)}
                className="Campaigns-input"
                placeholder="Название"
              />
            </label>
            <div className="Campaigns-field">
              <span>Тип кампании</span>
              <FormControl fullWidth size="small">
                <Select
                  sx={selectSx}
                  displayEmpty
                  value={draftFilters.type}
                  onChange={(e) => handleDraftChange("type", e.target.value)}
                  MenuProps={filterSelectMenuProps}
                >
                  <MenuItem value="">Все кампании</MenuItem>
                  <MenuItem value="REACH">Охват</MenuItem>
                  <MenuItem value="TRAFFIC">Трафик</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="Campaigns-field">
              <span>Статус</span>
              <FormControl fullWidth size="small">
                <Select
                  sx={selectSx}
                  displayEmpty
                  value={draftFilters.status}
                  onChange={(e) => handleDraftChange("status", e.target.value)}
                  MenuProps={filterSelectMenuProps}
                >
                  <MenuItem value="">Все статусы</MenuItem>
                  <MenuItem value="INACTIVE">Неактивна</MenuItem>
                  <MenuItem value="WORK">Работает</MenuItem>
                  <MenuItem value="MODERATION">На модерации</MenuItem>
                  <MenuItem value="ERROR">Ошибка</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="Campaigns-field Campaigns-field--wide">
              <span>Дата создания</span>
              <div className="Campaigns-date">
                <DateFromTo
                  key={`draft-created-${filtersModalOpen}-${hasDraftCreatedAt}`}
                  withoutStartDate={!hasDraftCreatedAt}
                  from={draftFilters.created_at.date_start || undefined}
                  to={draftFilters.created_at.date_end || undefined}
                  handleChange={(value) =>
                    handleDraftChange("created_at", {
                      date_end: value[1] ?? "",
                      date_start: value[0] ?? "",
                    })
                  }
                />
              </div>
            </div>
            <div className="Campaigns-field Campaigns-field--wide">
              <span>Период действия</span>
              <div className="Campaigns-date">
                <DateFromTo
                  key={`draft-range-${filtersModalOpen}-${hasDraftRange}`}
                  withoutStartDate={!hasDraftRange}
                  from={draftFilters.range.date_start || undefined}
                  to={draftFilters.range.date_end || undefined}
                  handleChange={(value) =>
                    handleDraftChange("range", {
                      date_end: value[1] ?? "",
                      date_start: value[0] ?? "",
                    })
                  }
                />
              </div>
            </div>
            <div className="Campaigns-field">
              <span>Дневной бюджет</span>
              <div className="Campaigns-rangeInputs">
                <input
                  value={draftFilters.daily_budget.start}
                  onChange={(e) =>
                    handleDraftChange("daily_budget", {
                      ...draftFilters.daily_budget,
                      start: e.target.value,
                    })
                  }
                  placeholder="от"
                />
                <input
                  value={draftFilters.daily_budget.end}
                  onChange={(e) =>
                    handleDraftChange("daily_budget", {
                      ...draftFilters.daily_budget,
                      end: e.target.value,
                    })
                  }
                  placeholder="до"
                />
              </div>
            </div>
            <div className="Campaigns-field">
              <span>Общий бюджет</span>
              <div className="Campaigns-rangeInputs">
                <input
                  value={draftFilters.full_budget.start}
                  onChange={(e) =>
                    handleDraftChange("full_budget", {
                      ...draftFilters.full_budget,
                      start: e.target.value,
                    })
                  }
                  placeholder="от"
                />
                <input
                  value={draftFilters.full_budget.end}
                  onChange={(e) =>
                    handleDraftChange("full_budget", {
                      ...draftFilters.full_budget,
                      end: e.target.value,
                    })
                  }
                  placeholder="до"
                />
              </div>
            </div>
            <div className="Campaigns-field">
              <span>Ставка</span>
              <div className="Campaigns-rangeInputs">
                <input
                  value={draftFilters.bet.start}
                  onChange={(e) =>
                    handleDraftChange("bet", {
                      ...draftFilters.bet,
                      start: e.target.value,
                    })
                  }
                  placeholder="от"
                />
                <input
                  value={draftFilters.bet.end}
                  onChange={(e) =>
                    handleDraftChange("bet", {
                      ...draftFilters.bet,
                      end: e.target.value,
                    })
                  }
                  placeholder="до"
                />
              </div>
            </div>
            <div className="Campaigns-field">
              <span>Сумма списаний</span>
              <div className="Campaigns-rangeInputs">
                <input
                  value={draftFilters.decrease.start}
                  onChange={(e) =>
                    handleDraftChange("decrease", {
                      ...draftFilters.decrease,
                      start: e.target.value,
                    })
                  }
                  placeholder="от"
                />
                <input
                  value={draftFilters.decrease.end}
                  onChange={(e) =>
                    handleDraftChange("decrease", {
                      ...draftFilters.decrease,
                      end: e.target.value,
                    })
                  }
                  placeholder="до"
                />
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="CampaignsFiltersDialog-actions">
          <Button onClick={resetDraftFilters} color="inherit">
            Очистить
          </Button>
          <Button onClick={() => setFiltersModalOpen(false)} color="inherit">
            Отмена
          </Button>
          <Button onClick={applyDraftFilters} variant="contained">
            Применить
          </Button>
        </DialogActions>
      </Dialog>

      <EditModal
        modal={editModal}
        campaing={current}
        handleCloseModal={() => setEditModal(false)}
      />
      <EditStatusModal
        modal={statusModal}
        handleCloseModal={() => setStatusModal(false)}
        campaing={current}
        upd={() => setUpd((prev) => !prev)}
      />
      <DeleteModal
        modal={isDeleteModal}
        handleCloseEdit={() => setDeleteModal(false)}
        campaing={current}
      />
      {ctrViewModal && (
        <CtrViewModal
          modal={ctrViewModal}
          handleCloseEdit={() => setCtrViewModal(false)}
          campaing={current}
        />
      )}

      <Dialog
        open={impressionsModal}
        onClose={closeImpressionsModal}
        maxWidth="md"
        fullWidth
        className="CampaignsImpressionsDialog"
        PaperProps={{ className: "CampaignsImpressionsDialog-paper" }}
      >
        <DialogTitle className="CampaignsImpressionsDialog-title">
          Управление показами
        </DialogTitle>
        <DialogContent className="CampaignsImpressionsDialog-content" dividers>
          <div className="CampaignsImpressions-meta">
            <div>
              <span>Кампания</span>
              <strong>{current?.name || "—"}</strong>
            </div>
            <div>
              <span>ID</span>
              <strong>{current?.id || "—"}</strong>
            </div>
            <div>
              <span>Тип</span>
              <strong>
                {TARGET_TYPE[current?.target_type] || current?.target_type || "—"}
              </strong>
            </div>
          </div>

          {!impressionsResult ? (
            <div className="CampaignsImpressions-form">
              <div className="CampaignsImpressions-field">
                <span>Объявления</span>
                <FormControl fullWidth size="small">
                  <Select
                    sx={selectSx}
                    multiple
                    displayEmpty
                    value={
                      impressionsForm.allAdvertisements
                        ? ["__all__"]
                        : impressionsForm.advertisementIds
                    }
                    disabled={impressionsAdsLoading}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const values =
                        typeof raw === "string" ? raw.split(",") : raw;
                      if (values.includes("__all__")) {
                        const pickedIds = values.filter((id) => id !== "__all__");
                        if (impressionsForm.allAdvertisements && pickedIds.length) {
                          updateImpressionsForm({
                            allAdvertisements: false,
                            advertisementIds: pickedIds,
                          });
                          return;
                        }
                        updateImpressionsForm({
                          allAdvertisements: !impressionsForm.allAdvertisements,
                          advertisementIds: [],
                        });
                        return;
                      }
                      updateImpressionsForm({
                        allAdvertisements: false,
                        advertisementIds: values.filter((id) => id !== "__all__"),
                      });
                    }}
                    renderValue={(selected) => {
                      if (impressionsForm.allAdvertisements || selected?.includes?.("__all__")) {
                        return "Все показы кампании, включая удалённые";
                      }
                      if (!selected?.length) {
                        if (impressionsAdsLoading) return "Загрузка объявлений...";
                        if (!impressionsAds.length) return "Нет объявлений";
                        return impressionsForm.mode === "delete"
                          ? "Все объявления кампании"
                          : "Выберите одно или несколько";
                      }
                      const selectedAds = impressionsAds.filter((ad) =>
                        selected.includes(String(ad.id))
                      );
                      if (selectedAds.length === impressionsAds.length) {
                        return `Выбрано всё · ${selectedAds.length}`;
                      }
                      return (
                        <div className="CampaignsImpressions-selectedValue">
                          {selectedAds.slice(0, 3).map((ad) => (
                            <span
                              key={ad.id}
                              className="CampaignsImpressions-selectedChip"
                            >
                              {ad.preview_url &&
                              String(ad.preview_extension || "").toLowerCase() !==
                                "mp4" ? (
                                <img
                                  src={ad.preview_url}
                                  alt=""
                                  className="CampaignsImpressions-selectedThumb"
                                  referrerPolicy="no-referrer"
                                />
                              ) : null}
                              <span className="CampaignsImpressions-selectedLabel">
                                {(ad.head || String(ad.id).slice(0, 8)).slice(0, 28)}
                                {(ad.head || "").length > 28 ? "…" : ""}
                              </span>
                            </span>
                          ))}
                          {selectedAds.length > 3
                            ? ` +${selectedAds.length - 3}`
                            : null}
                        </div>
                      );
                    }}
                    MenuProps={impressionsAdsMenuProps}
                  >
                    <MenuItem
                      value="__all__"
                      className="CampaignsImpressions-adItem CampaignsImpressions-adItem--all"
                    >
                      {impressionsForm.allAdvertisements ? "Снять всё" : "Выбрать всё"}
                    </MenuItem>
                    {impressionsAds.map((ad) => {
                      const isVideo =
                        String(ad.preview_extension || "").toLowerCase() === "mp4";
                      return (
                        <MenuItem
                          key={ad.id}
                          value={String(ad.id)}
                          className="CampaignsImpressions-adItem"
                        >
                          <div className="CampaignsImpressions-adOption">
                            <div className="CampaignsImpressions-adThumb">
                              {ad.preview_url ? (
                                isVideo ? (
                                  <video
                                    src={ad.preview_url}
                                    muted
                                    playsInline
                                    className="CampaignsImpressions-adThumbMedia"
                                    referrerPolicy="no-referrer"
                                  />
                                ) : (
                                  <img
                                    src={ad.preview_url}
                                    alt=""
                                    className="CampaignsImpressions-adThumbMedia"
                                    referrerPolicy="no-referrer"
                                  />
                                )
                              ) : (
                                <span className="CampaignsImpressions-adThumbEmpty">
                                  нет
                                </span>
                              )}
                            </div>
                            <div className="CampaignsImpressions-adMeta">
                              <span className="CampaignsImpressions-adTitle">
                                {(ad.head || "Без названия").slice(0, 70)}
                                {ad.head && ad.head.length > 70 ? "…" : ""}
                              </span>
                              {ad.text ? (
                                <span className="CampaignsImpressions-adDesc">
                                  {String(ad.text).slice(0, 90)}
                                  {String(ad.text).length > 90 ? "…" : ""}
                                </span>
                              ) : null}
                              <span className="CampaignsImpressions-adSub">
                                {ad.banners_count || 0} банн.
                                {ad.status ? ` · ${ad.status}` : ""}
                              </span>
                            </div>
                          </div>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {impressionsForm.allAdvertisements ? (
                  <div className="CampaignsImpressions-adHint">
                    {impressionsForm.mode === "delete"
                      ? "Будут удалены все REACH-показы кампании за выбранные дни, включая баннеры удалённых объявлений."
                      : impressionsForm.mode === "replace"
                        ? "Сначала удалятся все REACH-показы кампании за выбранные дни, включая баннеры удалённых объявлений. Новые показы запишутся на текущие объявления."
                        : "Новые показы будут разделены между всеми текущими объявлениями кампании."}
                  </div>
                ) : null}
                {impressionsForm.mode === "delete" &&
                !impressionsForm.allAdvertisements &&
                !impressionsForm.advertisementIds?.length ? (
                  <div className="CampaignsImpressions-adHint">
                    Объявления не выбраны — будут удалены все REACH-показы кампании
                    за выбранные дни.
                  </div>
                ) : null}
                {!impressionsForm.allAdvertisements &&
                impressionsForm.advertisementIds?.length > 0 && (
                  <div className="CampaignsImpressions-adHint">
                    {impressionsForm.mode === "delete"
                      ? impressionsForm.advertisementIds.length === 1
                        ? "Будут полностью удалены REACH-показы по баннерам выбранного объявления за выбранные дни."
                        : `Будут полностью удалены REACH-показы по баннерам ${impressionsForm.advertisementIds.length} объявлений за выбранные дни.`
                      : impressionsForm.advertisementIds.length === 1
                        ? "Показы будут привязаны к баннерам выбранного объявления."
                        : `Показы будут равномерно разделены между ${impressionsForm.advertisementIds.length} объявлениями.`}
                    {impressionsForm.mode === "replace"
                      ? " Замена затронет только статистику баннеров выбранных объявлений."
                      : ""}
                  </div>
                )}
              </div>

              <div className="CampaignsImpressions-field">
                <span>Режим</span>
                <RadioGroup
                  row
                  value={impressionsForm.mode}
                  onChange={(e) => updateImpressionsForm({ mode: e.target.value })}
                >
                  <FormControlLabel value="add" control={<Radio />} label="Добавить" />
                  <FormControlLabel value="replace" control={<Radio />} label="Заменить" />
                  <FormControlLabel value="delete" control={<Radio />} label="Удалить" />
                </RadioGroup>
              </div>

              {impressionsForm.mode === "replace" && (
                <div className="CampaignsImpressions-warning">
                  {impressionsForm.allAdvertisements
                    ? "Существующие REACH-показы выбранных дней по всей кампании, включая удалённые объявления, будут удалены, затем вставится новое количество на текущие объявления."
                    : "Существующие REACH-показы выбранных дней по баннерам выбранного объявления будут удалены, затем вставится новое количество."}
                </div>
              )}

              {impressionsForm.mode === "delete" && (
                <div className="CampaignsImpressions-warning">
                  {impressionsForm.allAdvertisements ||
                  !impressionsForm.advertisementIds?.length
                    ? "REACH-показы выбранных дней по всей кампании будут удалены полностью, без вставки новых значений."
                    : "REACH-показы выбранных дней по баннерам выбранных объявлений будут удалены полностью, без вставки новых значений."}
                </div>
              )}

              <div className="CampaignsImpressions-field">
                <span>Даты</span>
                <RadioGroup
                  row
                  value={impressionsForm.dateMode}
                  onChange={(e) =>
                    updateImpressionsForm({ dateMode: e.target.value })
                  }
                >
                  <FormControlLabel value="period" control={<Radio />} label="Период" />
                  <FormControlLabel
                    value="days"
                    control={<Radio />}
                    label="Отдельные дни"
                  />
                </RadioGroup>
              </div>

              {impressionsForm.dateMode === "period" ? (
                <div className="CampaignsImpressions-field CampaignsImpressions-field--wide">
                  <span>Период</span>
                  <div className="Campaigns-date">
                    <DateFromTo
                      key={`impressions-period-${impressionsModal}-${hasImpressionsPeriod}`}
                      withoutStartDate={!hasImpressionsPeriod}
                      from={impressionsForm.period.date_start || undefined}
                      to={impressionsForm.period.date_end || undefined}
                      handleChange={(value) =>
                        updateImpressionsForm({
                          period: {
                            date_start: value[0] ?? "",
                            date_end: value[1] ?? "",
                          },
                        })
                      }
                    />
                  </div>
                </div>
              ) : (
                <div className="CampaignsImpressions-field CampaignsImpressions-field--wide">
                  <span>Отдельные дни</span>
                  <div className="CampaignsImpressions-daysPicker">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Дата"
                        value={impressionsForm.dayToAdd}
                        mask="__/__/____"
                        inputFormat="dd/MM/yyyy"
                        onChange={(value) => updateImpressionsForm({ dayToAdd: value })}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                    <Button variant="outlined" onClick={addSelectedDay}>
                      Добавить день
                    </Button>
                  </div>
                  <div className="CampaignsImpressions-chips">
                    {impressionsForm.selectedDays.map((day) => (
                      <Chip
                        key={day}
                        label={formatDisplayDate(day)}
                        onDelete={() => removeSelectedDay(day)}
                        size="small"
                      />
                    ))}
                  </div>
                </div>
              )}

              {impressionsForm.mode !== "delete" && (
                <>
                  <div className="CampaignsImpressions-field">
                    <span>Распределение количества</span>
                    <RadioGroup
                      row
                      value={impressionsForm.amountMode}
                      onChange={(e) =>
                        updateImpressionsForm({ amountMode: e.target.value })
                      }
                    >
                      <FormControlLabel
                        value="daily_average"
                        control={<Radio />}
                        label="Среднее за день"
                      />
                      <FormControlLabel
                        value="period_total"
                        control={<Radio />}
                        label="Всего за период"
                      />
                    </RadioGroup>
                  </div>

                  <div className="CampaignsImpressions-field">
                    <span>
                      {impressionsForm.amountMode === "period_total"
                        ? "Сумма показов за период"
                        : "Среднее количество показов в день"}
                    </span>
                    <TextField
                      type="number"
                      size="small"
                      value={impressionsForm.amount}
                      onChange={(e) => updateImpressionsForm({ amount: e.target.value })}
                      inputProps={{ min: 1, step: 1 }}
                      placeholder="Например, 30000"
                      fullWidth
                    />
                  </div>
                </>
              )}
            </div>
          ) : (
            <div className="CampaignsImpressions-result">
              <div className="CampaignsImpressions-summary">
                <div>
                  <span>Режим</span>
                  <strong>
                    {impressionsResult.mode === "replace"
                      ? "Заменить"
                      : impressionsResult.mode === "delete"
                        ? "Удалить"
                        : "Добавить"}
                  </strong>
                </div>
                <div>
                  <span>Объявления</span>
                  <strong>
                    {(() => {
                      const ids = (
                        impressionsResult.advertisement_ids ||
                        (impressionsResult.advertisement_id
                          ? [impressionsResult.advertisement_id]
                          : [])
                      ).map(String);
                      if (impressionsResult.all_advertisements) {
                        return "Все, включая удалённые";
                      }
                      if (!ids.length) {
                        return impressionsResult.mode === "delete"
                          ? "Все"
                          : "—";
                      }
                      return String(ids.length);
                    })()}
                  </strong>
                </div>
                <div>
                  <span>Дней обработано</span>
                  <strong>
                    {impressionsResult.totals?.filled_days || 0} /{" "}
                    {impressionsResult.totals?.target_days || 0}
                  </strong>
                </div>
                <div>
                  <span>Удалено</span>
                  <strong>{formatViews(impressionsResult.totals?.deleted_views)}</strong>
                </div>
                {impressionsResult.mode !== "delete" && (
                  <div>
                    <span>Добавлено</span>
                    <strong>{formatViews(impressionsResult.totals?.inserted_views)}</strong>
                  </div>
                )}
              </div>

              <div className="CampaignsImpressions-tableWrap">
                <table className="CampaignsImpressions-table">
                  <thead>
                    <tr>
                      <th>Дата</th>
                      <th>Было</th>
                      <th>Удалено</th>
                      {impressionsResult.mode !== "delete" && <th>Добавлено</th>}
                      <th>Стало</th>
                      <th>Статус</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(impressionsResult.days || []).map((day) => (
                      <tr key={day.date}>
                        <td>{formatDisplayDate(day.date)}</td>
                        <td>{formatViews(day.existing_views)}</td>
                        <td>{formatViews(day.deleted_views)}</td>
                        {impressionsResult.mode !== "delete" && (
                          <td>{formatViews(day.inserted_views)}</td>
                        )}
                        <td>{formatViews(day.resulting_views)}</td>
                        <td>
                          {day.status === "replaced"
                            ? "Заменено"
                            : day.status === "filled"
                              ? "Добавлено"
                              : day.status === "deleted"
                                ? "Удалено"
                                : day.status === "already_empty"
                                  ? "Уже пусто"
                                  : day.status === "already_filled"
                                    ? "Уже заполнено"
                                    : day.status === "skipped_no_source_rows"
                                      ? "Нет исходных данных"
                                      : day.status}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions className="CampaignsImpressionsDialog-actions">
          <Button onClick={closeImpressionsModal} color="inherit">
            {impressionsResult ? "Закрыть" : "Отмена"}
          </Button>
          {!impressionsResult && (
            <Button
              onClick={submitImpressions}
              variant="contained"
              color={impressionsForm.mode === "delete" ? "error" : "primary"}
              disabled={impressionsSubmitting}
            >
              {impressionsSubmitting
                ? "Обработка..."
                : impressionsForm.mode === "replace"
                  ? "Заменить показы"
                  : impressionsForm.mode === "delete"
                    ? "Удалить показы"
                    : "Добавить показы"}
            </Button>
          )}
          {impressionsResult && (
            <Button
              onClick={() => {
                setImpressionsResult(null);
                setImpressionsForm(INIT_IMPRESSIONS_FORM);
              }}
              variant="contained"
            >
              Новая операция
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Campaigns;
